import { defineMessages } from 'react-intl';

const messages = defineMessages({
  divider: {
    id: 'Divider',
    defaultMessage: 'Divider',
  },
  size: {
    id: 'Thickness',
    defaultMessage: 'Thickness',
  },
  spacing: {
    id: 'Spacing',
    defaultMessage: 'Spacing',
  },
  small: {
    id: 'Thiner',
    defaultMessage: 'Thiner',
  },
  medium: {
    id: 'Medium',
    defaultMessage: 'Medium',
  },
  large: {
    id: 'Thicker',
    defaultMessage: 'Thicker',
  },
  dashed: {
    id: 'Dashed',
    defaultMessage: 'Dashed',
  },
});

export const schemaDivider = ({ intl }) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.divider),
        fields: ['size', 'spacing', 'dashed'],
      },
    ],
    properties: {
      // TODO: trocar por radio buttons ou buttons com icones
      size: {
        title: intl.formatMessage(messages.size),
        required: false,
        noValueOption: false,
        default: 'sm',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['sm', intl.formatMessage(messages.small)],
          ['md', intl.formatMessage(messages.medium)],
          ['lg', intl.formatMessage(messages.large)],
        ],
      },
      spacing: {
        title: intl.formatMessage(messages.spacing),
        description: (
          <>
            Leia mais sobre os espaçamentos do{' '}
            <a
              href="https://www.gov.br/ds/fundamentos-visuais/espacamento"
              target="_blank"
              rel="noreferrer"
            >
              Design System do Gov.br
            </a>
          </>
        ),
        noValueOption: false,
        default: '3',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['1', 'half (4px)'],
          ['2', 'base (8px)'],
          ['3', '2x (16px)'],
          ['4', '3x (24px)'],
          ['5', '4x (32px)'],
          ['6', '5x (40px)'],
        ],
      },
      dashed: {
        title: intl.formatMessage(messages.dashed),
        required: false,
        default: false,
        type: 'boolean',
      },
    },
  };
};

export default schemaDivider;
